import React, { useEffect, useState, useContext } from "react";
import { Card } from "@mui/material";
import CreateDomesticStayReq from "../../../Classes/Models/Requests/Accounting/CreateDomesticStayReq";
import { CardHeader } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import AsyncSelect from "react-select/async";
import AccountingApi from "../../../Classes/API/AccountingApi";
import { LanguageContext } from "App";
import searchUsersReq from "../../../Classes/Models/Requests/Users/SearchUser";
import QuickDate from "../../../components/QuickDate";
import UsersApi from "../../../Classes/API/UsersApi";
import UserTypes from "../../../Classes/Models/Requests/Users/UserTypes";
import "./stay-search.scss";
import Swal from "sweetalert2";

const StaySearch = ({ setSearchReq }) => {
  let req = new CreateDomesticStayReq();

  const [PatientsSearch, setPatientsSearch] = useState();
  const [Patient, setPatient] = useState();
  const { translations } = useContext(LanguageContext);
  const [StayId, setStayId] = useState();
  const [Notes, setNotes] = useState();
  const [StartDate, setStartDate] = useState(new Date());
  const [StartDateTo, setStartDateTo] = useState(new Date());
  const [EndDate, setEndDate] = useState(new Date());
  const [EndDateTo, setEndDateTo] = useState(new Date());
  const [NumberOfDays, setNumberOfDays] = useState();
  const [NumberOfDaysTo, setNumberOfDaysTo] = useState();
  const [RoomId, setRoomId] = useState();
  const [RoomType, setRoomType] = useState();
  const [Price, setPrice] = useState();
  const [PriceTo, setPriceTo] = useState();

  const [OptionPatient, setOptionPatient] = useState([]);

  useEffect(() => {
    GetPatients().then((res) => {
      setOptionPatient(res);
    });
  }, []);

  const GetPatients = async (inputValue = "") => {
    let searchReq = new searchUsersReq();
    let UserTypes1 = new UserTypes();

    searchReq.name = inputValue;
    searchReq.userType = UserTypes1.Patient;
    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      let optionsArr = res.data.list.map((item) => ({
        value: item,
        label: item.name,
      }));
      if (inputValue) {
        optionsArr = optionsArr.filter((item) =>
          item.label.toLowerCase().includes(inputValue.toLowerCase())
        );
      }
      return optionsArr;
    }
    return [];
  };

  const onSearchClick = async () => {
    req.PatientId = Patient && Patient.id;
    req.StartDate = StartDate;
    req.StartDateSearchTo = StartDateTo;
    req.EndDate = EndDate;
    req.EndDateSearchTo = EndDateTo;
    req.NumberOfDays = NumberOfDays;
    req.NumberOfDaysSearchTo = NumberOfDaysTo;
    req.RoomId = RoomId;
    req.RoomType = RoomType;
    req.Price = Price;
    req.PriceSearchTo = PriceTo;
    req.Notes = Notes;
    req.Id = StayId;
    if (StartDate) {
      console.log(StartDate);
      req.StartDate = new Date(StartDate + "T00:00:00");
    }
    if (StartDateTo) {
      req.StartDateSearchTo = new Date(StartDateTo + "T23:59:59");
    }
    if (EndDate) {
      req.EndDate = new Date(EndDate + "T00:00:00");
    }
    if (EndDateTo) {
      req.EndDateSearchTo = new Date(EndDateTo + "T23:59:59");
    }

    setSearchReq(req);
  };

  const onSearchNoDatesClick = async () => {
    req.PatientId = Patient && Patient.id;
    req.StartDate = undefined;
    req.StartDateSearchTo = undefined;
    req.EndDate = undefined;
    req.EndDateSearchTo = undefined;
    req.NumberOfDays = NumberOfDays;
    req.NumberOfDaysSearchTo = NumberOfDaysTo;
    req.RoomId = RoomId;
    req.RoomType = RoomType;
    req.Price = Price;
    req.PriceSearchTo = PriceTo;
    req.Notes = Notes;
    req.Id = StayId;
    req.pagingParams = { page: 1, pageSize: 10 };

    setSearchReq(req);
  };

  return (
    <Card sx={{ padding: "1em" }}>
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          {translations.PatientStayStaySearch}
        </MDTypography>
        <div>
          <MDButton
            type="button"
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            color="text"
            onClick={() => onSearchClick()}
          >
            {translations.usrBalanceEnteriesSearch}
          </MDButton>
          {/*                     <button type="button" className='btn btn-primary mt-2 mr-2' onClick={() => onSearchNoDatesClick()}>Search No Dates</button>
           */}{" "}
        </div>
      </MDBox>
      <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
        <div className="container-fluid mt-3">
          <div className="row">
            <div className="col-md-3">
              <MDInput
                label={translations.PatientStayStayId}
                onChange={(e) => setStayId(e.target.value)}
                type="number"
                style={{ width: "100%" }}
                fullWidth
              />
            </div>

            <div className="col-md-3" style={{ position: "relative", zIndex: "12" }}>
              <MDTypography mr={2} variant="button" fontWeight="regular" color="text">
                <AsyncSelect
                  isClearable={true}
                  placeholder={translations.PatientStaySelectPatient}
                  defaultOptions={OptionPatient}
                  loadOptions={(inputValue) => GetPatients(inputValue)}
                  onInputChange={setPatientsSearch}
                  onChange={(e) => setPatient(e ? e.value : "")}
                  // value={TypeId}
                  style={{ width: "100%", position: "relative", zIndex: "9999" }}
                  styles={
                    translations.setlang === "ar"
                      ? {
                          control: (base) => ({
                            ...base,
                            direction: "rtl", // This will rotate the arrow to the left and the text to the right
                          }),
                          placeholder: (base) => ({
                            ...base,
                            textAlign: "right", // Align placeholder text to the right
                          }),
                          singleValue: (base) => ({
                            ...base,
                            textAlign: "right", // Align selected value text to the right
                          }),
                        }
                      : {}
                  }
                />
              </MDTypography>
            </div>

            <div className="col-md-3">
              <MDInput
                label={translations.CreateDomesticStayRoomId}
                value={RoomId}
                onChange={(e) => setRoomId(e.target.value)}
                style={{ width: "100%" }}
                fullWidth
              />
            </div>

            <div className="col-md-3">
              <MDInput
                label={translations.CreateDomesticStayRoomType}
                value={RoomType}
                onChange={(e) => setRoomType(e.target.value)}
                style={{ width: "100%" }}
                fullWidth
              />
            </div>
            <div className="col-md-3">
              <MDInput
                label={translations.PatientStayPriceTo}
                onChange={(e) => setPriceTo(e.target.value)}
                type="number"
                style={{ width: "100%" }}
                fullWidth
              />
            </div>

            <div className="col-md-3">
              <MDInput
                label={translations.PatientStayNumberOfDaysFrom}
                mr={2}
                onChange={(e) => setNumberOfDays(e.target.value)}
                type="number"
                style={{ width: "100%" }}
                fullWidth
              />
            </div>
            <div className="col-md-3">
              <MDInput
                label={translations.PatientStayNumberOfDaysTo}
                onChange={(e) => setNumberOfDaysTo(e.target.value)}
                type="number"
                style={{ width: "100%" }}
                fullWidth
              />
            </div>

            <div className="col-md-3">
              <MDInput
                label={translations.PatientStayPriceFrom}
                mr={2}
                onChange={(e) => setPrice(e.target.value)}
                type="number"
                style={{ width: "100%" }}
                fullWidth
              />
            </div>

            <div className="col-md-12 mt-3 mb-3">
              <MDInput
                label={translations.CreateDomesticStayNotes}
                multiline
                rows={3}
                value={Notes}
                onChange={(e) => setNotes(e.target.value)}
                style={{ width: "100%" }}
                fullWidth
              />
            </div>
            <div className="col-md-9"></div>

            <div className="col-md-6">
              <div className="qd">
                <div className="quick_date_container">
                  <p>{translations.PatientStayQuickDate}</p>
                  <QuickDate
                    setFrom={setStartDate}
                    setTo={setStartDateTo}
                    placeholder={"Quick Last Updated"}
                  />
                </div>
                <div className="date-range-container">
                  <label>{translations.PatientStayStartDateFrom}:</label>
                  <div
                    className="quick_date"
                    style={{
                      width: "auto",
                      ...(window.innerWidth <= 768 && { width: "100%" }),
                    }}
                  >
                    <input
                      type="date"
                      style={{
                        width: "auto",
                        ...(window.innerWidth <= 768 && { width: "100%" }),
                      }}
                      onChange={(e) => {
                        setStartDate(e.target.value);
                      }}
                      value={StartDate}
                    />
                    <p>{translations.PatientStayTo}</p>
                    <input
                      type="date"
                      style={{
                        width: "auto",
                        ...(window.innerWidth <= 768 && { width: "100%" }),
                      }}
                      onChange={(e) => {
                        setStartDateTo(e.target.value);
                      }}
                      value={StartDateTo}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="qd">
                <div className="quick_date_container">
                  <p>{translations.PatientStayQuickDate}</p>
                  <QuickDate
                    setFrom={setEndDate}
                    setTo={setEndDateTo}
                    placeholder={"Quick Last Updated"}
                  />
                </div>
                <div className="date-range-container">
                  <label>{translations.PatientStayEndDateFrom}:</label>
                  <div className="quick_date">
                    <input
                      type="date"
                      style={{
                        width: "auto",
                        ...(window.innerWidth <= 768 && { width: "100%" }),
                      }}
                      onChange={(e) => {
                        setEndDate(e.target.value);
                      }}
                      value={EndDate}
                    />
                    <p>{translations.PatientStayTo}:</p>
                    <input
                      type="date"
                      style={{
                        width: "auto",
                        ...(window.innerWidth <= 768 && { width: "100%" }),
                      }}
                      onChange={(e) => {
                        setEndDateTo(e.target.value);
                      }}
                      value={EndDateTo}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default StaySearch;
